/**
 * Front-end gedrag van de site.
 *
 * De opmaak komt uit de overgenomen Drupal-stylesheet (assets/css/legacy.css).
 * Die stylesheet verwacht dat JavaScript een paar dingen doet, en dat is wat
 * hier gebeurt: het hamburgermenu open/dicht klappen, de body vastzetten zolang
 * het menu open staat, en het FAQ-filter zichzelf laten versturen.
 */
(() => {
    'use strict';

    // ── markering dat JavaScript beschikbaar is ─────────────────────────────
    // Drupal zet hiervoor `class="js"` op <html>; de legacy-stylesheet hangt
    // daar `.js-hide` aan op. Bij het scopen onder `.glx-legacy` is die regel
    // onbruikbaar geworden, dus zetten we een eigen markering die wp-bridge.css
    // gebruikt. Zonder JavaScript blijft alles dus gewoon zichtbaar.
    document.querySelectorAll('.glx-legacy').forEach((el) => el.classList.add('glx-js'));

    // ── FAQ-filter wisselt alleen de lijst om ──────────────────────────────
    // De oude site gebruikt Better Exposed Filters: een categorie aanklikken
    // filtert meteen, typen na 500ms rust.
    //
    // Dat ging eerst met een echte paginaverversing naar `…#faq`. Werkte, maar
    // flikkerde: de browser tekent eerst de bovenkant van de pagina en springt
    // pas naar `#faq` zodra hij dat element in de HTML tegenkomt. Gemeten op
    // 1440px: twee frames op scrollY 0, dan een sprong naar 793 en daarna nog
    // een correctie naar 737. Dat is de lichtflits.
    //
    // Daarom halen we nu alleen de nieuwe pagina op en wisselen we daaruit
    // `.faq-list` om. Geen flits, en de bezoeker blijft exact staan waar hij
    // stond. Zonder JavaScript verandert er niets: het formulier verstuurt
    // zichzelf dan gewoon met GET naar zijn `action`, `#faq` incluis, en dat
    // fragment blijft ook in de pagerlinks staan.
    const faq     = document.getElementById('faq');
    const faqForm = faq && faq.querySelector('form.views-exposed-form');

    if (faq && faqForm && window.fetch && window.DOMParser) {
        // Antwoorden kunnen in een andere volgorde binnenkomen dan ze zijn
        // aangevraagd; alleen de laatste aanvraag mag de lijst nog aanraken.
        let volgnummer = 0;
        let tikTimer   = null;

        // De URL die het formulier in zijn huidige stand zou versturen.
        const formulierUrl = () => {
            const url = new URL(faqForm.getAttribute('action') || window.location.href, window.location.href);
            const q   = new URLSearchParams(new FormData(faqForm));

            // Een leeg zoekveld hoort niet in de URL. `category` blijft er wél
            // altijd in staan, ook als die 'all' is: zonder die parameter valt
            // de server terug op de categorie uit het pad, en dan zou ALLE op
            // /veel-gestelde-vragen/algemeen niets doen.
            if (!q.get('combine')) {
                q.delete('combine');
            }

            url.search = q.toString();
            url.hash   = 'faq';

            return url;
        };

        /**
         * Haalt `url` op en zet daaruit de nieuwe lijst op zijn plaats.
         *
         * opties.vervang          — geschiedenis overschrijven i.p.v. aanvullen
         * opties.geschiedenis     — op false laten bij terug/vooruit
         * opties.herstelFormulier — radio's en zoekveld meenemen uit het antwoord
         * opties.naarBoven        — naar de bovenkant van de lijst scrollen
         */
        const laadLijst = (url, opties) => {
            const o     = opties || {};
            const mijn  = ++volgnummer;

            // Pas dimmen als het merkbaar lang duurt. Meteen dimmen zou bij een
            // snel antwoord precies de flits geven die we kwijt wilden.
            const dimmen = window.setTimeout(() => {
                if (mijn === volgnummer) {
                    faq.classList.add('glx-faq-laadt');
                }
            }, 200);

            return window.fetch(url.href, { credentials: 'same-origin' })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error('status ' + res.status);
                    }

                    return res.text();
                })
                .then((html) => {
                    if (mijn !== volgnummer) {
                        return;
                    }

                    const vers  = new DOMParser().parseFromString(html, 'text/html');
                    const nieuw = vers.querySelector('#faq .faq-list');
                    const oud   = faq.querySelector('.faq-list');

                    if (!nieuw || !oud) {
                        throw new Error('geen lijst in het antwoord');
                    }

                    oud.replaceWith(document.importNode(nieuw, true));

                    // Bij terug/vooruit staat het formulier nog op de vorige
                    // keuze. Die halen we uit het antwoord zelf, zodat ook
                    // /veel-gestelde-vragen/<categorie> goed terugkomt.
                    if (o.herstelFormulier) {
                        const bronVeld = vers.querySelector('#faq-combine');
                        const eigenVeld = faqForm.querySelector('#faq-combine');

                        if (bronVeld && eigenVeld) {
                            eigenVeld.value = bronVeld.value;
                        }

                        const bronKeuze = vers.querySelector('#faq input[type="radio"]:checked');

                        if (bronKeuze) {
                            faqForm.querySelectorAll('input[type="radio"]').forEach((r) => {
                                r.checked = r.value === bronKeuze.value;
                            });
                        }
                    }

                    if (false !== o.geschiedenis) {
                        window.history[o.vervang ? 'replaceState' : 'pushState']({}, '', url.href);
                    }

                    // Na een pagerklik hoor je weer bovenaan de lijst te staan.
                    // Na filteren blijf je juist staan waar je stond — tenzij
                    // een korter resultaat de pagina zo veel inkort dat de lijst
                    // helemaal buiten beeld valt.
                    const doos = faq.getBoundingClientRect();

                    if (o.naarBoven || doos.bottom < 80 || doos.top > window.innerHeight - 80) {
                        faq.scrollIntoView({ block: 'start' });
                    }
                })
                .catch(() => {
                    // Netwerk weg, of onverwachte markup: dan maar op de oude
                    // manier, met een gewone verversing.
                    if (mijn === volgnummer) {
                        window.location.assign(url.href);
                    }
                })
                .then(() => {
                    window.clearTimeout(dimmen);

                    if (mijn === volgnummer) {
                        faq.classList.remove('glx-faq-laadt');
                    }
                });
        };

        faqForm.addEventListener('change', (e) => {
            if (e.target.matches('input[type="radio"]')) {
                window.clearTimeout(tikTimer);
                laadLijst(formulierUrl());
            }
        });

        // Enter in het zoekveld verstuurt het formulier. Zonder JavaScript is
        // dat een gewone verversing; met JavaScript hoeft dat niet.
        faqForm.addEventListener('submit', (e) => {
            e.preventDefault();
            window.clearTimeout(tikTimer);
            laadLijst(formulierUrl());
        });

        const zoekveld = faqForm.querySelector('input[type="text"]');

        if (zoekveld) {
            zoekveld.addEventListener('input', () => {
                window.clearTimeout(tikTimer);
                // Tikken overschrijft de vorige stand, anders moet je bij
                // 'terug' evenveel keer klikken als je letters typte.
                tikTimer = window.setTimeout(() => laadLijst(formulierUrl(), { vervang: true }), 500);
            });
        }

        // De pager wordt bij elke wissel opnieuw getekend, dus luisteren we op
        // `#faq` zelf. Klikken met ctrl/cmd of de middelste knop laten we met
        // rust: dat hoort een nieuw tabblad te openen.
        faq.addEventListener('click', (e) => {
            if (0 !== e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
                return;
            }

            const link = e.target.closest('.pagerer-container a[href]');

            if (!link) {
                return;
            }

            e.preventDefault();
            laadLijst(new URL(link.getAttribute('href'), window.location.href), { naarBoven: true });
        });

        window.addEventListener('popstate', () => {
            laadLijst(new URL(window.location.href), { geschiedenis: false, herstelFormulier: true });
        });
    }

    const btn = document.getElementById('menubtn');
    const nav = document.querySelector('#header .nav ul.menu');

    if (btn && nav) {
        const isOpen = () => btn.classList.contains('open');

        const setOpen = (open) => {
            btn.classList.toggle('open', open);
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            document.body.classList.toggle('menu_open', open);
            // Openen gebeurt met een class, niet met een inline stijl. De lijst
            // staat tot en met 1100px verborgen met `display:none !important` — dat
            // moet wel, want legacy.css zet er vanaf 768px zelf een
            // `display:block !important` op. Een inline `display:block` verliest
            // daarvan; de class-regel in wp-bridge.css (sectie 6) is specifieker
            // en wint wel.
            nav.classList.toggle('glx-menu-open', open);
        };

        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Menu openen');

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            setOpen(!isOpen());
        });

        // Sluiten na navigatie of met Escape.
        nav.addEventListener('click', (e) => {
            if (e.target.closest('a')) {
                setOpen(false);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isOpen()) {
                setOpen(false);
            }
        });

        // Bij het overschakelen naar desktop het menu weer sluiten. Dezelfde
        // grens als de breakpoint in wp-bridge.css sectie 6 (max-width:1100px).
        window.addEventListener('resize', () => {
            if (window.innerWidth > 1100 && isOpen()) {
                setOpen(false);
            }
        });
    }
})();
